import React, { Suspense } from 'react'

// React 19 replacement for react-loadable (deprecated, broken under React 19 —
// its legacy contextTypes API was removed). Keeps the exact same call signature
// and return type (a component) so routes.js requires zero changes:
//   component: loadable(() => import('../pages/home'))
// Code splitting itself is intentional and stays — this only swaps the mechanism.
const loadable = (loader, extraProps) => {
  const LazyComponent = React.lazy(loader)

  return function LoadableRoute(props) {
    return (
      <Suspense fallback={<div />}>
        <LazyComponent {...props} {...extraProps} />
      </Suspense>
    )
  }
}

export default loadable
